
import {
  onBeforeMount,
  onUnmounted,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
} from "vue";
import BeforeUpload from '@/components/Aio/star3/BeforeUpload.vue'
import NoteStrategy from '@/components/Aio/star3/NoteStrategy.vue'
import NoteProgress from '@/components/Aio/star3/NoteProgress.vue'
import CommentsRes from '@/components/Aio/star3/CommentsRes.vue'
import AioConfirm from "@/components/Aio/AioConfirm.vue"
import { registerFnHandler } from "@/utils/registerFnHandler";
import { takeResources, previewResources, nativeUploadResources } from '@/utils/nativeFn';
import UploadProgress from "@/components/Aio/star3/UploadProgress.vue";
export default {
  name: 'Star3Demo',
  components: {
    BeforeUpload,
    NoteStrategy,
    AioConfirm,
    NoteProgress,
    CommentsRes,
    UploadProgress
},
  setup(props, { emit }) {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const callUploadActions = [
      { name: '拍照', type: 'camera' },
      { name: '从相册选择', type: 'library', className: 'actionSheetItem' },
    ]
    const strategyVisible = ref(false)
    const callUploadActionVisible = ref(false)
    const delNoteConfirmVisible = ref(false)
    const uploadProgressVisible = ref(true)
    const strategyFirstShow = ref(false)
    const total = ref(5)
    const doneNum = ref(1)
    const cancelUpload = () => {
      uploadProgressVisible.value = false
    }
    const showProgressUpload = () => {
      uploadProgressVisible.value = true
      let timer = setInterval(() => {
        doneNum.value = doneNum.value + 1
        if (doneNum.value >= total.value) {
          clearInterval(timer)
        }
      }, 800)
    }
    const delConfirmInfo = reactive({
      subTitle: '确定删除该笔记吗？',
      cancelText: '取消',
      confirmText: '确定',
      doClose: () => {
        delNoteConfirmVisible.value = false
      },
      doConfirm: () => {
        delNoteConfirmVisible.value = false
      },
    })
    const noteList = ref([{
      resource: 'https://sites.xueersibook.com/h5-ibook/images/logo.png',
      uri: '',
      type: 'urlStr',
      status: 0,
      message: ''
    }])
    const progressList = ref([
        {
          desc: '上传笔记',
          status: 'done'
        },
        {
          desc: '笔记批改',
          status: 'pendding'
        },
        // {
        //   desc: '未通过',
        //   status: 'fail'
        // },
        {
          desc: '批改完成',
          status: 'todo'
        }
      ])
    // 调起上传actionsheet
    const callUploadAction = () => {
      strategyVisible.value = false
      callUploadActionVisible.value = true
    }
    // 处理上传actionsheet的选中
    const handleSelectUploadAction = (item) => {

      callUploadActionVisible.value = false
      takeResources({
        type: item.type,
        maxCount: 6 - noteList.value.length,
        sourceType: 'image',
        from: 'star3'
      })
    }
    const handlePreview = (index) => {
      console.log(noteList.value.map(item => ({
          title: '',
          type: item.resource.indexOf('http') !== 0 ? 'base64' : 'urlStr',
          resource: item.uri || item.resource
        })), '图片预览')
      previewResources({
        initIndex: index,
        data: noteList.value.map(item => ({
          title: '',
          type: item.resource.indexOf('http') !== 0 ? 'uriStr' : 'urlStr',
          resource: item.uri || item.resource
        }))
      })
    }
    const takeResourcesCallback = (data) => {
      noteList.value = noteList.value.concat(data)
      console.log(noteList.value, '选择的图片列表')
    }
    const uploadResources = () => {
      let data = [];
      noteList.value.forEach((item, index) => {
        item.type !== 'urlStr' && data.push({
          index,
          resource: item.uri,
          type: 'uriStr',
          status: 0
        })
      })
      total.value = data.length
      doneNum.value = 0
      nativeUploadResources({
        from: 'noteUpload',
        data
      })
    }
    const handleProgress = (res) => {
      console.log(res, '进度信息')
      let { from = '', resource, index, status, message = '' } = res || {}
      if (status === '0') {
        doneNum.value = doneNum.value + 1
      }
      let type = status === '0' && resource.includes('http') ? 'urlStr' : noteList.value?.[index]?.type
      if (from === 'noteUpload') {
        noteList.value.splice(index, 1, {...noteList.value[index], resource, status, message, type})
      }
    }
    const showStrategy = () => {
      strategyFirstShow.value = localStorage.getItem('strategyFirstShow') !== '1'
      localStorage.setItem('strategyFirstShow', '1')
      strategyVisible.value = true
    }
    const showDelNoteConfirm = () => {
      delNoteConfirmVisible.value = true
    }
    onMounted(() => {
      // 注册选择图片的回调
      registerFnHandler('takeResourcesCallback', (res) => {
        const { from = '', data = '[]', sourceType = ''  } = res || {}
        try {
          takeResourcesCallback(typeof data === "string" ? JSON.parse(data) : data);
        }catch(err) {
          console.log(err)
        }
      })
      // 图片上传进度回调 
      registerFnHandler('uploadResourceCallBack', (res = {}) => {
        // console.log(typeof res, '上传进度')
        handleProgress(res)
      })
    })
    return {
      strategyVisible,
      callUploadActionVisible,
      strategyFirstShow,
      callUploadActions,
      noteList,
      delNoteConfirmVisible,
      delConfirmInfo,
      progressList,
      total,
      doneNum,
      uploadProgressVisible,
      callUploadAction,
      handleSelectUploadAction,
      handlePreview,
      showStrategy,
      showDelNoteConfirm,
      uploadResources,
      showProgressUpload,
      cancelUpload,
    };
  },
};
